/** AP_GL05 copy (one group per control; a ticket edits only its own file). */
export const apGl05PtBr = {
  title: 'GL05 — revisões contábeis pendentes',
  description: 'Contas a pagar com revisão contábil pendente até a competência do fechamento.',
  prerequisite: '',
  detail: {
    listLabel: 'Contas com revisão pendente',
    competencyLabel: 'Competência',
    competencyEstimated: '(competência estimada)',
    documentUnavailable: 'Documento excluído ou indisponível',
    amountUnavailable: 'Valor contábil da conta indisponível; cobertura parcial.',
    billId: 'Conta a pagar',
    reviewIds: 'Solicitações de revisão',
    reviewCount_one: '{{count}} revisão',
    reviewCount_other: '{{count}} revisões',
    reviewTypes: {
      flag: 'Sinalizado manualmente',
      classification: 'Alteração de classificação',
      statutoryFallback: 'Fallback contábil',
      unmatchedStatutory: 'Tributo sem correspondência',
      other: 'Revisão contábil',
    },
    ageLabel: 'Pendente há',
    ageDays_one: '{{count}} dia',
    ageDays_other: '{{count}} dias',
    amountLabel: 'Valor da conta',
    openBill: 'Abrir conta',
  },
};

export const apGl05En: typeof apGl05PtBr = {
  title: 'GL05 — pending accounting reviews',
  description: 'AP bills with an accounting review pending through the close competency.',
  prerequisite: '',
  detail: {
    listLabel: 'Bills with pending reviews',
    competencyLabel: 'Competency',
    competencyEstimated: '(estimated competency)',
    documentUnavailable: 'Document deleted or unavailable',
    amountUnavailable: 'Bill accounting amount unavailable; coverage is partial.',
    billId: 'AP bill',
    reviewIds: 'Review requests',
    reviewCount_one: '{{count}} review',
    reviewCount_other: '{{count}} reviews',
    reviewTypes: {
      flag: 'Flagged manually',
      classification: 'Classification change',
      statutoryFallback: 'Statutory accounting fallback',
      unmatchedStatutory: 'Unmatched statutory tax',
      other: 'Accounting review',
    },
    ageLabel: 'Pending for',
    ageDays_one: '{{count}} day',
    ageDays_other: '{{count}} days',
    amountLabel: 'Bill amount',
    openBill: 'Open bill',
  },
};
